function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M105.98315,46.85156a1.99855,1.99855,0,0,0-2.8281.03906l-5.041,5.18359a2,2,0,1,0,2.86716,2.78906l5.041-5.18359A1.99946,1.99946,0,0,0,105.98315,46.85156Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M109.88936,56.84082a1.99771,1.99771,0,0,0-2.54392-1.23535l-4.34371,1.50488a1.99972,1.99972,0,1,0,1.30858,3.7793l4.34371-1.50488A1.99973,1.99973,0,0,0,109.88936,56.84082Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M96.0272,43.0957a1.9989,1.9989,0,0,0-2.51462,1.29395l-1.417,4.41992a1.9997,1.9997,0,1,0,3.80856,1.2207l1.417-4.41992A1.999,1.999,0,0,0,96.0272,43.0957Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M28.95561,77.23535a2.0024,2.0024,0,0,0-2.80954-.33105l-5.65912,4.4668a2.0004,2.0004,0,0,0,2.47849,3.14063l5.65912-4.4668A2.00126,2.00126,0,0,0,28.95561,77.23535Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M20.35022,74.748l4.38667-.77832a2.00051,2.00051,0,0,0-.69921-3.93945l-4.38667.77832a2.00023,2.00023,0,0,0,.34765,3.96973A2.06016,2.06016,0,0,0,20.35022,74.748Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M32.86768,81.87012a2.00431,2.00431,0,0,0-2.6699.93555l-2.081,4.32715a2.00045,2.00045,0,0,0,3.60543,1.73438l2.081-4.32715A2.00129,2.00129,0,0,0,32.86768,81.87012Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M88.99993,56H63.00019L86.444,5.00739C87.678,2.03821,86.80372,0,85.06521,0c-1.25731,0-2.96646,1.06537-4.65779,3.61505l-46.696,64.60345C30.45993,72.56543,31.87416,76,37.00045,76h19.9998L34.67631,122.65851C33.2572,125.64984,33.92754,128,35.78806,128c1.24108,0,3.01151-1.04492,5.04548-3.64252L91.983,63.71271C95.54008,59.6626,94.12671,56,88.99993,56Zm-.02234,5.07312q-.02637.03-.05218.06067L41.833,116.96832,60.60849,77.72638A4,4,0,0,0,57.00025,72H37.00045a5.44343,5.44343,0,0,1-.87823-.06409,6.47335,6.47335,0,0,1,.79223-1.32147l.03876-.05273L78.03074,13.73132,59.36595,54.3291A4,4,0,0,0,63.00019,60H88.99993a5.22114,5.22114,0,0,1,.72259.04614A6.007,6.007,0,0,1,88.97759,61.07312Z"
});

function SvgTechTips(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "-15 -10 150 150",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "miscellaneous102 expandline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechTips);
export default __webpack_public_path__ + "static/media/TechTips.8ae5358f.svg";
export { ForwardRef as ReactComponent };